import { useQuery } from '@tanstack/react-query';

import { CurrentUserDocument } from '../../../services/queries/currentUserDocument';
import { CacheKeys, graphQLClient } from '../../models/utils/constants';

const useLoadCurrentUser = () => {
  return useQuery({
    queryKey: [CacheKeys.currentUser],
    queryFn: async () => graphQLClient.request(CurrentUserDocument),
  });
};

export default useLoadCurrentUser;
